import { FormType } from '../../../types/types';
import loginSettingsParams from '../../Login/settingsParams';
import signupSettingsParams from '../../Signup/settingsParams';
import loginStylesParams from '../../Login/stylesParams';
import signupStylesParams from '../../Signup/stylesParams';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import {
  UseTitleSettingsParams,
  TitleSettings,
  LoginTitleSettings,
} from './settings.types';

const PARAMS: Record<FormType, TitleSettings> = {
  login: loginSettingsParams,
  signup: signupSettingsParams,
};

const STYLE_PARAMS = {
  login: loginStylesParams,
  signup: signupStylesParams,
};

export const useTitleSettings = ({
  formType,
  ssoMandatory,
}: UseTitleSettingsParams) => {
  const settings = useSettings();
  const styles = useStyles();

  if (!(formType in PARAMS)) {
    return {};
  }

  const settingsParams = PARAMS[formType];
  const stylesParams = STYLE_PARAMS[formType];

  const isTitleVisible = styles.get(stylesParams.showTitle);
  const titleText = settings.get(settingsParams.formTitleText);

  // Handle subtitle visibility - only login has mandatory SSO subtitle setting
  const isSubtitleVisible =
    ssoMandatory && formType === 'login'
      ? styles.get(stylesParams.showMandatorySSOSubtitle)
      : styles.get(stylesParams.showSubtitle);

  // Handle subtitle text - only login has mandatory SSO subtitle
  const subtitleText =
    ssoMandatory && formType === 'login'
      ? settings.get(
          (settingsParams as LoginTitleSettings).mandatorySSOSubtitle,
        )
      : settings.get(settingsParams.formSubtitleText);

  return { isTitleVisible, isSubtitleVisible, titleText, subtitleText };
};
